import React, { Component } from "react";
import qs from "qs";
import { Col, CardBody, Row } from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Statistics from "../compliance/components/Statistics";
import { signout } from "../../../redux/actions/userActions";
import { loadEnabledFrameworks } from "../../../redux/actions/complianceActions";
import { setReload } from "../../../redux/actions/apolloActions";
import { Link } from "react-router-dom";
import TourNotActive from "../TourNotActive";
import Tour from './Tour'

class TourDashboard extends Component {
  state = {
    showTrialAlert: true,
    open: false
  };

  componentWillMount() {
    return this.props.user ? null : this.props.history.push("/unauthorized");
  }

  componentDidMount() {
    const values = qs.parse(this.props.location.search.slice(1));

    if (this.props.dataLoaded && values.mf && values.mf === "open") {
      this.setState({ open: true });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps || this.state.open !== nextState.open
      ? true
      : false;
  }

  closeAlert() {
    this.setState({ showTrialAlert: false });
  }

  // modalBody() {
  //   return <ComplianceToggleForm />;
  // }

  emptyDashboardCard() {
    return (
      <div>
        <Col
          className="card project-summary__statistics"
          style={{ float: "left" }}
        >
          <CardBody className="no-frameworks-selected">
            <p className="no-frameworks-body"> No frameworks selected </p>
          </CardBody>
        </Col>
        <div>
          <Col
            md={7}
            className=" card project-summary__statistics"
            style={{ float: "left" }}
          >
            <CardBody className="dashboard-card">
              <div className="project-summary__statistic_quick">
                <h5 className="project-summary__statistic-title">Quick Menu</h5>
                {this.props.enabledFrameworks &&
                  this.props.enabledFrameworks.length > 0
                  ? this.props.enabledFrameworks.map(f => {
                    return (
                      <Link
                        className="primary-dashboard-link"
                        key={f.name}
                        to={`/app/compliance/${f.path}`}
                      >
                        <h4>{f.humanName} Controls</h4>
                      </Link>
                    );
                  })
                  : null}
                <Link className="primary-dashboard-link" to="/app/training">
                  <h4>Training</h4>
                </Link>
                <Link className="primary-dashboard-link" to="/logout">
                  <h4>Logout</h4>
                </Link>
              </div>
            </CardBody>
          </Col>
        </div>
      </div>
    );
  }

  signoutUser() {
    this.props.signout();
    this.props.history.push("/");
  }

  render() {
    const {toggleTour} = this.props;
    return (
      <div>
      { toggleTour.toggleOn ? <div>
        <Tour/>
        <div className="dashboard">
          <Row>
            {
              <div style={{ width: "100%" }}>
                {!this.props.dataLoaded && (
                  <div
                    className={`custom_load load${this.props.dataLoaded ? "" : " loaded"
                      }`}
                  >
                    <div className="load__icon-wrap">
                      <svg className="load__icon">
                        <path
                          fill="#2d9aa6"
                          d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
                        />
                      </svg>
                    </div>
                  </div>
                )}
                <div>
                  <h3 className="page-title">
                    {this.props.compliance} Dashboard
                    </h3>
                  <h3 className="page-subhead subhead">
                    Gain a high-level view of your organization's compliance activity.
                    </h3>
                  {["dev", "development", "qa", "demo", "prod", undefined].includes(
                    process.env.REACT_APP_ENV
                  ) && this.props.user['cognito:groups'] &&
                    this.props.user['cognito:groups'].find(e => { if (e === 'PostureAdmin') { return true } if (e === 'ComplianceManager') { return true } }) && (
                      <React.Fragment>
                        <button
                          style={{ marginRight: "0" }}
                          className={`dashboard btn btn-primary add-compliance`}
                          onClick={() => {
                            this.setState({
                              open: !this.state.open
                            });
                          }}
                        >
                          Manage Frameworks
                        </button>
                      </React.Fragment>
                    )}
                    <Statistics />
                </div>
              </div>
            }
          </Row>
        </div>
      </div>: <TourNotActive/>}
    </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    enabledFrameworks: state.controlsData.enabledFrameworks,
    dataLoaded: !state.controlsData.loading,
    sidebar: state.sidebar,
    toggleTour: state.toggleTour
  };
}

export default connect(mapStateToProps, {
  signout,
  setReload,
  loadEnabledFrameworks,
})(withRouter(TourDashboard));


// WEBPACK FOOTER //
// ./src/components/tour/dashboard/TourDashboard.js